const carouselItems = [
  {
    id: 1,
    title: '顶流塌房全纪录：从巅峰到谷底，2024最全吃瓜时间线',
    excerpt: '年度重磅爆料合集，梳理多位顶流艺人从被曝到实锤的完整过程，时间线梳理、证据链汇总、各方回应一网打尽，吃瓜必读系列。',
    tag: '年度盘点',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20breaking%20news%20visual%20with%20dark%20atmosphere%20and%20warm%20orange%20glowing%20accents%2C%20abstract%20representation%20of%20celebrity%20scandal%20and%20public%20fallout%2C%20newspaper%20headlines%20collage%20style%2C%20dramatic%20spotlight%20effect%2C%20editorial%20photography%20with%20high%20contrast%2C%20mysterious%20and%20urgent%20mood&width=600&height=340&seq=carousel-01&orientation=landscape',
    heat: '980万热度',
  },
  {
    id: 2,
    title: '网红圈大洗牌：带货一姐翻车始末，千万粉丝账号说没就没',
    excerpt: '从直播间封禁到账号注销，深度解析头部网红因虚假宣传、偷税漏税等问题被全网封杀的全过程，行业震荡持续发酵。',
    tag: '深度追踪',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20social%20media%20livestream%20scene%20with%20dark%20moody%20lighting%2C%20smartphone%20screen%20glowing%20in%20darkness%2C%20red%20warning%20symbols%2C%20abstract%20digital%20chaos%2C%20warm%20crimson%20and%20dark%20tones%2C%20modern%20minimalist%20composition%2C%20tense%20atmosphere&width=600&height=340&seq=carousel-02&orientation=landscape',
    heat: '860万热度',
  },
  {
    id: 3,
    title: '综艺名场面翻车实录：那些被剪掉的尴尬瞬间全网疯传',
    excerpt: '多家综艺节目录制现场失控画面流出，从选手互撕到导师失态，节目组紧急公关仍挡不住吃瓜群众的热情传播。',
    tag: '名场面',
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20show%20stage%20with%20dramatic%20lighting%2C%20abstract%20audience%20silhouettes%2C%20warm%20spotlight%20beams%2C%20dark%20ambiance%20with%20golden%20accents%2C%20suspenseful%20atmosphere%2C%20editorial%20photography%20style%2C%20high%20contrast%20dramatic%20composition&width=600&height=340&seq=carousel-03&orientation=landscape',
    heat: '750万热度',
  },
  {
    id: 4,
    title: '科技圈大地震：某大厂高管内部群聊曝光，行业潜规则浮出水面',
    excerpt: '匿名爆料人放出多张内部聊天截图，涉及行业巨头不正当竞争、员工权益侵害等敏感话题，引发全网讨论和监管部门关注。',
    tag: '独家爆料',
    image: 'https://readdy.ai/api/search-image?query=Dark%20corporate%20office%20environment%20with%20glowing%20screens%2C%20abstract%20data%20leak%20visualization%2C%20warm%20orange%20alert%20tones%2C%20mysterious%20atmosphere%2C%20modern%20tech%20aesthetic%2C%20dramatic%20shadows%2C%20editorial%20photography%20with%20tense%20mood&width=600&height=340&seq=carousel-04&orientation=landscape',
    heat: '690万热度',
  },
  {
    id: 5,
    title: '吃瓜地图：各省年度热门爆料TOP榜，看看你的省份上榜了吗',
    excerpt: '根据全年数据统计，盘点各省份最受关注的本地爆料事件，从南方到北方，吃瓜文化的地域差异和特色事件大盘点。',
    tag: '数据盘点',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20map%20visualization%20with%20warm%20data%20points%20glowing%2C%20dark%20background%20with%20orange%20and%20amber%20highlights%2C%20trending%20topics%20heatmap%20style%2C%20modern%20infographic%20aesthetic%2C%20editorial%20design%2C%20clean%20geometric%20composition&width=600&height=340&seq=carousel-05&orientation=landscape',
    heat: '620万热度',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            焦点爆料
          </h2>
          <p className="text-sm text-foreground-500 mt-2">本周最受关注的吃瓜大事件，热度爆表</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {carouselItems.map((item, idx) => (
            <article
              key={item.id}
              className={`group bg-background-50 border border-background-200 rounded-xl overflow-hidden transition-all duration-300 hover:border-accent-300 cursor-pointer ${
                idx === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              } ${idx === 1 ? 'lg:col-span-3' : ''}`}
            >
              <div className={`relative overflow-hidden ${idx === 0 ? 'aspect-[16/10]' : 'aspect-[16/9]'}`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={idx > 1 ? 'lazy' : undefined}
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full text-[10px] font-medium bg-accent-500 text-white whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="inline-flex items-center gap-1 text-[11px] text-white/90 bg-black/40 backdrop-blur-sm px-2 py-0.5 rounded-full">
                    <i className="ri-fire-line text-accent-400"></i>
                    {item.heat}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 group-hover:text-accent-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
                  {item.excerpt}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}